function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMore = function SvgMore(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    id: "navigation/more"
  }, /*#__PURE__*/React.createElement("g", {
    id: "fill"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.75 12C13.75 12.9665 12.9665 13.75 12 13.75C11.0335 13.75 10.25 12.9665 10.25 12C10.25 11.0335 11.0335 10.25 12 10.25C12.9665 10.25 13.75 11.0335 13.75 12Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.75 12C5.75 12.9665 4.9665 13.75 4 13.75C3.0335 13.75 2.25 12.9665 2.25 12C2.25 11.0335 3.0335 10.25 4 10.25C4.9665 10.25 5.75 11.0335 5.75 12Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.75 12C21.75 12.9665 20.9665 13.75 20 13.75C19.0335 13.75 18.25 12.9665 18.25 12C18.25 11.0335 19.0335 10.25 20 10.25C20.9665 10.25 21.75 11.0335 21.75 12Z",
    fill: "currentColor"
  }))));
};
SvgMore.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "SvgMore"
};
export default SvgMore;